import React from 'react';
import { useChatTheme } from '../../contexts/ChatThemeContext';

interface TypingIndicatorProps {
  userName?: string;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ userName }) => {
  const { theme } = useChatTheme();

  return (
    <div style={{ 
      display: 'flex', 
      marginBottom: theme.spacing.messageGap,
      alignItems: 'flex-end',
      gap: '8px'
    }}>
      <div
        className="typing-indicator"
        style={{
          display: 'flex',
          gap: '4px',
          padding: '14px 18px',
          background: theme.colors.typingBackground,
          borderRadius: theme.borderRadius.bubble,
          width: 'fit-content',
          boxShadow: theme.shadows.typingIndicator,
          border: `1px solid ${theme.name === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.04)'}`,
        }}
      >
        <div
          className="typing-dot"
          style={{
            width: '8px',
            height: '8px',
            background: theme.colors.typingDot,
            borderRadius: '50%',
            animation: 'typing 1.4s infinite',
          }}
        />
        <div
          className="typing-dot"
          style={{
            width: '8px',
            height: '8px',
            background: theme.colors.typingDot,
            borderRadius: '50%',
            animation: 'typing 1.4s infinite',
            animationDelay: '0.2s',
          }}
        />
        <div
          className="typing-dot"
          style={{
            width: '8px',
            height: '8px',
            background: theme.colors.typingDot,
            borderRadius: '50%',
            animation: 'typing 1.4s infinite',
            animationDelay: '0.4s',
          }}
        />
      </div>
      
      {userName && (
        <span style={{
          fontSize: '12px',
          color: theme.colors.mutedText,
          marginBottom: '4px',
        }}>
          {userName} is typing...
        </span>
      )}
    </div>
  );
};